const SCHEMA: string = process.env.REACT_APP_MAESTRO_SEDE_SCHEMA || '';
const ENTITY: string = process.env.REACT_APP_MAESTRO_SEDE_ENTITY || '';
const ACTION_ITEM_REJECT = ['SOLICITUD RECHAZADA', 'SOLICITUD PRE RECHAZADA'];

export const AdapterConfigure = {
    SCHEMA,
    ENTITY,
    ACTION_ITEM_REJECT
}